"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMedia = void 0;
var react_1 = __importDefault(require("react"));
var react_responsive_carousel_1 = require("react-responsive-carousel");
var classnames_1 = __importDefault(require("classnames"));
var Skeleton_1 = __importDefault(require("../Skeleton/Skeleton"));
var NoImage_1 = require("../NoImage");
var GeneralSettings_1 = require("../../constants/GeneralSettings");
var deviceHelper_1 = require("../../helpers/deviceHelper");
var mediaHelper_1 = require("../../helpers/mediaHelper");
var useMediaPreview_1 = require("../../hooks/useMediaPreview");
require("react-responsive-carousel/lib/styles/carousel.min.css");
var PostMedia = function (_a) {
    var media = _a.media, _b = _a.mobileView, mobileView = _b === void 0 ? false : _b, skeleton = _a.skeleton;
    var openPreview = useMediaPreview_1.useMediaPreview();
    var SKELETON_COUNT = 6;
    var isPlaceholder = function (m) {
        if (!m) {
            return false;
        }
        var type = m.type;
        return type === GeneralSettings_1.MEDIA_TYPES.DOCUMENT || type === GeneralSettings_1.MEDIA_TYPES.VIDEO;
    };
    var is3DTour = function (m) {
        return m.type === GeneralSettings_1.MEDIA_TYPES.TOUR_3D;
    };
    var extractPrimary = function () {
        if (!media) {
            return;
        }
        return media[0];
    };
    var composeViewerMedia = function () {
        var primary = extractPrimary();
        if (primary && !is3DTour(primary)) {
            return media;
        }
        return excludePrimary();
    };
    var excludePrimary = function () {
        if (!media) {
            return [];
        }
        var primary = media[0], rest = media.slice(1);
        return rest;
    };
    var getPrimaryImage = function (primary) {
        if ((primary === null || primary === void 0 ? void 0 : primary.type) === GeneralSettings_1.MEDIA_TYPES.TOUR_3D) {
            return (react_1.default.createElement("iframe", { src: primary.path, frameBorder: "0", allowFullScreen: true, allow: "xr-spatial-tracking", className: "media" }));
        }
        return (react_1.default.createElement("img", { className: classnames_1.default('media', {
                placeholder_media: isPlaceholder(primary),
            }), src: mediaHelper_1.resolveThumb(primary), onClick: function () {
                openPreview(composeViewerMedia());
            }, title: "", alt: "" }));
    };
    var getDesktopView = function () {
        var primary = extractPrimary();
        var mediaList = excludePrimary();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            primary || skeleton ? (react_1.default.createElement("div", { className: "main-image" },
                react_1.default.createElement(Skeleton_1.default, null),
                !skeleton && getPrimaryImage(primary))) : (react_1.default.createElement("div", { className: "main-image" },
                react_1.default.createElement(NoImage_1.NoImage, null))),
            react_1.default.createElement("div", { className: "media-list" },
                mediaList &&
                    mediaList.map(function (item, index) {
                        return (react_1.default.createElement("div", { key: index, className: "media-item", onClick: function () {
                                var i = primary && is3DTour(primary)
                                    ? index
                                    : index + 1;
                                openPreview(composeViewerMedia(), i);
                            } },
                            react_1.default.createElement(Skeleton_1.default, null),
                            react_1.default.createElement("img", { src: mediaHelper_1.resolveThumb(item), alt: "../", className: classnames_1.default('media', {
                                    placeholder_media: isPlaceholder(item),
                                }) })));
                    }),
                skeleton &&
                    Array(SKELETON_COUNT)
                        .fill(null)
                        .map(function (item, index) {
                        return (react_1.default.createElement("div", { key: index, className: "media-item" },
                            react_1.default.createElement(Skeleton_1.default, null)));
                    }))));
    };
    var getMobileView = function () {
        var primary = extractPrimary();
        return (media === null || media === void 0 ? void 0 : media.length) || skeleton ? (react_1.default.createElement(react_responsive_carousel_1.Carousel, { showThumbs: false, showStatus: false, showArrows: false, onClickItem: function (index) {
                var m = media[index];
                if (is3DTour(m)) {
                    window.location.assign(m.path);
                    return;
                }
                // In mobile view we exclude 3d tour from preview
                var i = primary && is3DTour(primary) ? index - 1 : index;
                openPreview(composeViewerMedia(), i);
            } }, media === null || media === void 0 ? void 0 : media.map(function (m) {
            if (is3DTour(m)) {
                // For iframes swipe wont work, hence we overlay it
                // with a div, which will make it work
                return (react_1.default.createElement("div", { key: m.id },
                    react_1.default.createElement("div", { className: "tour-3d-overlay" }),
                    react_1.default.createElement("iframe", { src: m.path, frameBorder: "0", allowFullScreen: true, allow: "xr-spatial-tracking", className: "media" })));
            }
            return (react_1.default.createElement("div", { key: m.id },
                react_1.default.createElement("img", { className: classnames_1.default({
                        placeholder_media: isPlaceholder(m),
                    }), src: mediaHelper_1.resolveThumb(m), alt: ".../" })));
        }))) : (react_1.default.createElement("div", { className: "main-image" },
            react_1.default.createElement(NoImage_1.NoImage, null)));
    };
    if (mobileView && !deviceHelper_1.isMobile()) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "post-media " + (mobileView ? 'mobile-view' : '') }, mobileView ? getMobileView() : getDesktopView())));
};
exports.PostMedia = PostMedia;
